import { useState } from 'react';
import { Button, FormAutoGenerated, FormLoadingBox, Wrapper } from '@visualfabriq/vf-ui-kit';
import {
  FieldItem,
  FormLayoutRow,
} from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';

import { StepConfigLayout } from '../StepConfigLayout';
import { requiredField } from 'src/components/UIKitTweaks';
import { AzureInboundRetrieverStep } from 'src/dto/PipelineStep/AzureInboundRetrieverStep';

type Props = {
  step: AzureInboundRetrieverStep;
  defaultFieldsConfiguration: JSX.Element;
  loading: boolean;
  onUpdate: (step: AzureInboundRetrieverStep) => void;
  deleteButton: JSX.Element;
};

export function AzureInboundRetrieverStepConfig(props: Props) {
  const { defaultFieldsConfiguration, onUpdate, step, loading, deleteButton } = props;

  const [formState, setFormState] = useState(() => {
    const configuration = step.configuration;
    return {
      ...configuration,
      source_folder: configuration.source_folder || '',
      container_name: configuration.container_name || '',
      destination_folder: configuration.destination_folder || '',
    };
  });

  const handleUpdate = () => {
    onUpdate({
      ...step,
      configuration: {
        ...step.configuration,
        ...formState,
        source_folder: formState.source_folder === '' ? null : formState.source_folder,
        container_name: formState.container_name === '' ? null : formState.container_name,
        destination_folder: formState.destination_folder === '' ? null : formState.destination_folder,
      },
    });
  };

  return (
    <StepConfigLayout
      loader={<FormLoadingBox items={['text', 'text', 'text', 'text', 'text']} itemsCount={5} />}
      loading={loading}
      footer={
        <Wrapper gap="200" direction="column">
          <Button onClick={handleUpdate}>Update Step</Button>
          {deleteButton}
        </Wrapper>
      }
    >
      {defaultFieldsConfiguration}
      <FormAutoGenerated
        initData={formState}
        fields={fields}
        layout={layout}
        onDataChange={(event) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          setFormState(event as any);
        }}
      />
    </StepConfigLayout>
  );
}

const fields: FieldItem[] = [
  {
    field_id: 'file_search_expression',
    field_desc: 'File Search Expression',
    data_type: 'text',
    ...requiredField,
  },
  {
    field_id: 'source_folder',
    field_desc: 'Source Folder',
    data_type: 'text',
  },
  {
    field_id: 'container_name',
    field_desc: 'Container Name',
    data_type: 'text',
  },
  {
    field_id: 'blob_sas_token',
    field_desc: 'Blob SAS token',
    data_type: 'text',
    ...requiredField,
  },
  {
    field_id: 'blob_sas_url',
    field_desc: 'Blob SAS url',
    data_type: 'text',
    ...requiredField,
  },
  {
    field_id: 'destination_folder',
    field_desc: 'Destination Folder',
    data_type: 'text',
  },
  {
    field_id: 'delete_after',
    field_desc: 'Delete file after retrieval',
    data_type: 'boolean',
    ...requiredField,
  },
];

const layout: FormLayoutRow[] = fields.map(({ field_id }) => [{ field: field_id, cols: [4, 6, 12] }]);
